import { useReactiveVar } from '@apollo/client';
import { useNavigate } from '@tanstack/react-router';
import type React from 'react';
import { useCallback, useContext } from 'react';
import { HOME_PATH } from 'src/constants';
import { SharedLinkContext } from 'src/SharedLinkPage/context';
import viewStateVar from 'src/store/viewState';
import { SuperViewWrapper } from '../SuperView';
import { MediaCardContentSingleColumn } from './CardContent';
import type { ContentField } from './ContentField';

interface SharedFieldsProps extends React.HTMLAttributes<HTMLDivElement> {
  data?: ContentField[];
}

interface SharedCardContentProps {
  itemId: string;
}

export const SharedFields: React.FC<SharedFieldsProps> = ({ data, ...props }) => {
  return <MediaCardContentSingleColumn fields={data ?? []} {...props} />;
};

export const SharedCardContent: React.FC<SharedCardContentProps> = ({ itemId }) => {
  const { linkInfo, linkId } = useContext(SharedLinkContext);
  const viewState = useReactiveVar(viewStateVar);
  const { ViewMediaCardMinimalInfo } = viewState.viewModels.library;

  const navigate = useNavigate();

  const onClick = useCallback(() => {
    navigate({
      to: `${HOME_PATH}/shared/${linkId}/media-page/${itemId}`,
      search: {
        collectionId: linkInfo?.collectionId,
      },
    });
  }, [itemId, navigate, linkId, linkInfo?.collectionId]);

  const queryArgs = {
    variables: {
      globalId: itemId,
      viewComponentName: (ViewMediaCardMinimalInfo as { node?: { componentName?: string } } | null)?.node
        ?.componentName,
    },
    skip: !itemId || !(ViewMediaCardMinimalInfo as { node?: { componentName?: string } } | null)?.node?.componentName,
  };

  return (
    <div>
      <SuperViewWrapper useQueryArgs={queryArgs} shared={true}>
        <SharedFields onClick={onClick} />
      </SuperViewWrapper>
    </div>
  );
};
